const months = [
  'Jan.',
  'Feb.',
  'März',
  'Apr.',
  'Mai',
  'Juni',
  'Juli',
  'Aug.',
  'Sept.',
  'Okt.',
  'Nov.',
  'Dez.',
]
const monthsFull = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember',
]

const weekdays = [
  'Sonntag',
  'Montag',
  'Dienstag',
  'Mittwoch',
  'Donnerstag',
  'Freitag',
  'Samstag',
]

export const formatSwissDate = (a: string, type = 'short', locale = 'de') => {
  if (locale === 'fr') {
    // TODO: more options
    return new Date(a).toLocaleDateString('ch-FR', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
  } else {
    let parts = a.split('-')
    let month = months[parseInt(parts[1]) - 1]
    let monthFull = monthsFull[parseInt(parts[1]) - 1]
    let day = weekdays[new Date(a).getDay()]
    if (type === 'short_chart') {
      return monthFull + ' ' + parts[0]
    }
    if (type === 'short') {
      return (
        parseInt(parts[2]) +
        '.' +
        parseInt(parts[1]) +
        '.' +
        parts[0].substr(2, 2)
      )
    }
    if (type === 'extended') {
      return day + ', ' + parseInt(parts[2]) + '. ' + month + ' ' + parts[0]
    }
    return parseInt(parts[2]) + '. ' + month + ' ' + parts[0]
  }
}
